
    import { makeI18n } from '@/shared/lib/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/shared/legacy/ui/modals/start-vacancy.vue', {"vacancy_missing_permission_error":{"ru_RU":"У&nbsp;вас нет прав создавать и&nbsp;управлять вакансиями. Обратитесь к&nbsp;управляющему рекрутеру","en_US":"You do&nbsp;not have the rights to&nbsp;create and manage vacancies. Contact the managing recruiter"},"declined_taking_error":{"ru_RU":"Произошла ошибка: заявка уже была отклонена","en_US":"An error occurred: Vacancy request has already been declined"},"missing_value_selected":{"ru_RU":"Выбранное значение удалено","en_US":"A deleted value is selected"},"form.missing_value_selected":{"ru_RU":"Не удалось сохранить: было удалено выбранное значение из справочника. Выберите другое","en_US":"Failed to save: the selected value was deleted from the list. Select another"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/shared/legacy/ui/modals/start-vacancy.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  